import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { AbortRequestEnum } from '../../../../main/constants/abort-request.ts';
import { TrackingEventEnum } from '../../../../main/constants/tracking-event.ts';
import { resetSlicesStateThunk } from '../../../../main/slices/app-lifecycle/thunks/reset-slices-state.thunk.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getAwsAuthUtil } from '../../../../main/utils/aws/aws-auth.util.ts';
import { getReadingCrittersClientUtil } from '../../../../main/utils/clients/readingcritters.client.util.ts';
import { getTrackerUtil } from '../../../../main/utils/trackers/tracker.util.ts';

import { AUTH_SLICE_NAME, AuthSliceState } from '../auth.slice.types.ts';

import { resetUserTrackersThunk } from './reset-user-trackers.thunk.ts';

interface SignOutThunkProps {
  noAuthTokenReset?: boolean;
}

export const signOutThunk = createAsyncThunk<void, SignOutThunkProps | undefined, ThunkApiConfigType>(
  `${AUTH_SLICE_NAME}/signOut`,
  async (props, thunkAPI) => {
    const currentUser = thunkAPI.getState().accounts.currentAccount;
    getTrackerUtil().track({
      event: TrackingEventEnum.PARENT_SIGN_OUT,
      data: {
        parentEmail: currentUser?.email,
        parentName: currentUser?.preferredName,
        parentUUID: currentUser?.userId,
      },
    });
    getReadingCrittersClientUtil().abortAllRequests(AbortRequestEnum.USER_SIGN_OUT);
    await getReadingCrittersClientUtil().invalidateCacheForCurrentUser();

    if (!props?.noAuthTokenReset) {
      await getAwsAuthUtil().signOut();
    }

    thunkAPI.dispatch(resetUserTrackersThunk());
    thunkAPI.dispatch(resetSlicesStateThunk());
  }
);

export const signOutThunkExtraReducers = (builder: ActionReducerMapBuilder<AuthSliceState>): void => {
  builder.addCase(signOutThunk.pending, (state) => {
    state.isSignOutLoading = true;
  });

  builder.addCase(signOutThunk.fulfilled, (state) => {
    state.isSignOutLoading = false;
  });

  builder.addCase(signOutThunk.rejected, (state) => {
    state.isSignOutLoading = false;
  });
};
